import { useEffect, useState, Fragment } from 'react';
import { Button, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ErrorOutline, CheckCircleOutlined, InfoOutlined } from '@mui/icons-material';
import PropTypes from 'prop-types';

/**
 * @params
 *  isOpen (Boolean) = set modal open
 * onClose (Function) = set parent toggle to falsess
 */
export default function InfoModal({ data, onClose }) {
    const [open, setOpen] = useState(false);
    const { isOpen, title, message, content, type = 'info' } = data;

    const modalTheme = {
        error: {
            primary: '#f65f5f',
            hover: '#f65f5feb'
        },
        info: {
            primary: '#2da8de',
            hover: '#32ace1'
        },
        success: {
            primary: '#2ca58d',
            hover: '#2ca58db0'
        }
    };

    useEffect(() => {
        setOpen(isOpen || false);
    }, [isOpen]);

    const handleClose = () => {
        setOpen(false);
        onClose();
    };

    return (
        <Fragment>
            <Dialog
                open={open || false}
                size="small"
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                sx={{
                    '.MuiPaper-root': {
                        padding: 2,
                        width: '22rem',
                        minWidth: '27rem'
                    }
                }}
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center', mt: 1 }}>
                    {type === 'error' && (
                        <ErrorOutline
                            sx={{
                                fontSize: '3.5rem',
                                color: modalTheme[type].primary
                            }}
                        />
                    )}
                    {type === 'info' && (
                        <InfoOutlined
                            sx={{
                                fontSize: '3.5rem',
                                color: modalTheme[type].primary
                            }}
                        />
                    )}
                    {type === 'success' && (
                        <CheckCircleOutlined
                            sx={{
                                fontSize: '3.5rem',
                                color: modalTheme[type].primary
                            }}
                        />
                    )}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" sx={{ textAlign: 'center' }} component="div">
                        {title && <Typography sx={{ fontWeight: 500, fontSize: '1.15rem' }}>{title}</Typography>}
                        {message && (
                            <Typography
                                sx={{
                                    lineHeight: 1.2,
                                    fontSize: '0.86rem',
                                    mt: 0.5
                                }}
                            >
                                {message}
                            </Typography>
                        )}
                        {content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        autoFocus
                        variant="contained"
                        size="medium"
                        fullWidth
                        sx={{
                            background: modalTheme[type].primary,
                            '&:hover': {
                                background: modalTheme[type].hover
                            }
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

InfoModal.propTypes = {
    data: PropTypes.any,
    onClose: PropTypes.func
};
